export default __webpack_public_path__ + "static/meet-the-team-slide-1-e8fa5b9068b3a8733772ec82d157fc07.jpg";